var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 19",
    width: 30,
    height: 19,
    role: "img",
    "aria-label": "Mastercard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.591 9.795a9.18 9.18 0 013.41-7.146A9.158 9.158 0 009.203.591a9.205 9.205 0 000 18.409A9.158 9.158 0 0015 16.942a9.18 9.18 0 01-3.409-7.147",
    fill: "#E71513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.796.59A9.158 9.158 0 0015 2.65a9.18 9.18 0 013.409 7.146c0 2.887-1.33 5.46-3.41 7.148A9.163 9.163 0 0020.797 19a9.205 9.205 0 000-18.41",
    fill: "#ED9027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.409 9.795a9.18 9.18 0 00-3.41-7.146 9.18 9.18 0 00-3.408 7.146A9.18 9.18 0 0015 16.942a9.18 9.18 0 003.409-7.147",
    fill: "#FE4E18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.bfb733819c3c17f21c834fe4dc8abfbe.svg";
export { ForwardRef as ReactComponent };